import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Competition from "../views/Competition.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/competition",
    name: "Competition",
    component: Competition
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
